export default "__VITE_ASSET__BcodO0gQ__"